<template>
  <div class="swaychat-dropdown">
    <!--Dropdown Content-->
    <input type="file" ref="file" multiple="multiple" style="display:none" @change="fileUpload($event.target)">
    <div class="swaychat-dropdown-content">
      <ul id="swaychat-action">
        <li class="swaychat-sound" v-if="getSettings.sounds" @click="toggleSound" :class="{
          'swaychat-sound-on': !isMute,
          'swaychat-sound-off': isMute
        }">
          <span class="swaychat-icon-mute-chat"></span>
          <span class="swaychat-dropdown-list-text swaychat-text-mute-chat">{{ getLang.disable_sound }}</span>
          <span class="swaychat-icon-unmute-chat"></span>
          <span class="swaychat-dropdown-list-text swaychat-text-unmute-chat">{{ getLang.enable_sound }}</span>
        </li>
        <li class="swaychat-attach-files" v-if="!getSettings.no_upload && fileSupported" @click="triggerFile">
          <span class="swaychat-icon-attach"></span>
          <span class="swaychat-dropdown-list-text">{{ getLang.attach_file }}</span>
        </li>
        <li class="swaychat-dropdown-list-last"@click="showEnd">
          <span class="swaychat-icon-end-chat"></span>
          <span class="swaychat-dropdown-list-text">{{ getLang.end_chat }}</span>
        </li>
      </ul>
    </div>
    <!--Dropdown Content End-->
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      fileSupported: window && window.File && window.FileReader
    }
  },
  computed: {
    ...mapGetters([
      'getLang',
      'getSettings',
      'isMute'
    ])
  },
  methods: {
    toggleSound() {
      this.$store.dispatch('toggleSound')
    },
    triggerFile() {
      this.$emit('hide')
      this.$refs.file.click()
    },
    showEnd() {
      this.$store.dispatch('setEndState')
    },
    fileUpload(target) {
      this.$store.dispatch('postFile', target.files).then(()=>{
        target.value = ''
      })
    }
  }
}

</script>
